import React from "react";
import {
    Form,
    Row,
    Col,
    Select,
    Icon,
    Layout,
    Button,    
    message,
} from "antd";
import MiCompAPI from "../../util/api";
import img from '../../assets/img/At the office-pana 1.png';
import TableWrapper from "../elements/TableWrapper";
const { Content } = Layout;
const { Option } = Select;
class MI extends React.Component {
    constructor(props) {
        super(props);
        this.columns = [
            {
                title: 'Brokers',
                dataIndex: 'broker',                
                sorter: (a, b) => a.broker.localeCompare(b.broker),
                sortDirections: ["descend", "ascend"],
                render:(text,record)=>record.isExisting?<p style={{fontWeight:'bold'}}>{text+'(Current)'} </p>:text
            },
            {
                title: 'Plan',
                dataIndex: 'plan',
                sorter: (a, b) => a.plan.localeCompare(b.plan),
                sortDirections: ["descend", "ascend"]
            },
            {
                title: 'Carrier',
                dataIndex: 'carrier',
                sorter: (a, b) => a.carrier.localeCompare(b.carrier),
                sortDirections: ["descend", "ascend"]
            }
        ];
        this.state = {
            loas: [],
            familytype: [],
            broker: [],
            selectedRows: [],
            isLoading: false,
        };
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    componentDidMount = () => {
        this.getClientMasters();
        this.GetLoaForEnquiry();
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                var data = {
                    ...values, enquiryItems: this.state.selectedRows.map(x => {
                        return { brokerId: x.brokerId, carrierId: x.carrierId, plan: x.plan }
                    })
                };
                if (this.state.selectedRows && this.state.selectedRows.length > 0) {
                    this.InsertMemberEnquiry(data);
                } else {
                    message.destroy();
                    message.warning("Please select at least one broker", 3)
                }
            }
        });
    }
    InsertMemberEnquiry = (data) => {
        this.api.invoke(
            "InsertMemberEnquiry",
            "post",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        this.props.history.push("enquiry");
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            }, data
        );
    };
    getClientMasters() {       
        this.api.invoke(
            "GetMasters",
            "post",
            (data, success) => {
                if (success) {
                    this.setState({
                       
                        familytype: data.family_master
                    });
                }
            },
            [ "FAMILY_MASTER",]
        );
    }
    GetLoaForEnquiry = () => {
        this.setState({
            isLoading: true
        })
        this.api.invoke(
            "GetLoaForEnquiry/",
            "get",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        this.setState({
                            loas: data.data,
                            isLoading: false,
                        });
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            },
        );
    };
    GetBrokersByLoA = (id) => {
        this.setState({
            isLoading: true
        })
        this.api.invoke(
            "GetBrokersByLoA/" + id,
            "get",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        this.setState({
                            broker: data.data,
                            isLoading: false,
                        });
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            },
        );
    };
    onChange = (e) => {
        this.GetBrokersByLoA(e);
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Content>
                <div className="mi_main_div">
                    <div className="mi_box" style={{ marginLeft: '8px', marginRight: '8px', marginTop: '20px' }}>
                        <Row span={24}>
                            <Col span={18}>
                                <h4 className="mi_box_h4">Enquiry</h4>
                            </Col>
                            <Col span={6}>
                                <img alt="example" style={{ height: '182px', marginTop: '-80px' }} src={img} />
                            </Col>
                        </Row>
                    </div>
                    <div className="mi_main" style={{ marginTop: '-10px', marginLeft: '12px' }}>
                        <Row>
                            <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
                                <Row span={24}>
                                    <Col sm={11}>
                                        <Form.Item>
                                            <fieldset className="mi_input_pop" style={{ marginRight: '2px', marginLeft: "-1px" }}>
                                                <legend className="legend-font">LOA</legend>
                                                {getFieldDecorator('loAId',
                                                    {
                                                        rules: [{ required: true, message:<p style={{marginLeft:'-12px'}}> Please Select LOA. </p>}],
                                                    }
                                                )(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                                                    onChange={this.onChange}
                                                    showSearch={true}
                                                    filterOption={(input, Option) =>
                                                        Option.props.children
                                                            .toLowerCase()
                                                            .indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    placeholder="Please Select LOA">
                                                    {this.state.loas ? this.state.loas.map(x => <Option value={x.id} key={x.id}>{x.name}</Option>) : ""}
                                                </Select>
                                                )}
                                            </fieldset>
                                        </Form.Item>
                                    </Col>
                                    <Col sm={2}></Col>
                                    <Col sm={11}>
                                        <Form.Item>
                                            <fieldset className="mi_input_pop" style={{ marginRight: '2px', marginLeft: "-1px" }}>
                                                <legend className="legend-font">Family Type</legend>
                                                {getFieldDecorator('familyId',
                                                    {
                                                        rules: [{ required: true, message: <p style={{marginLeft:'-12px'}}>Please Select FamilyType.</p> }],
                                                    }
                                                )(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                                                    showSearch={true}
                                                    filterOption={(input, Option) =>
                                                        Option.props.children
                                                            .toLowerCase()
                                                            .indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    placeholder="Please Select Family Type">
                                                    {this.state.familytype ? this.state.familytype.map(x => <Option value={x.id} key={x.id}>{x.name}</Option>) : ""}
                                                </Select>
                                                )}
                                            </fieldset>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <TableWrapper
                                    rowSelectionType={true}
                                    handlerowChange={(keys, rows) => {
                                        this.setState({
                                            selectedRows: rows
                                        })
                                    }}
                                    rowKey="id"
                                    columns={this.columns}
                                    data={this.state.broker}
                                    title="Enquiries"
                                    search={true}
                                    loading={this.state.isLoading}
                                />

                                <Row span={24} style={{ marginTop: "30px", float: "right", marginRight: '98px' }} >
                                    <Col span={18}></Col>
                                    <Col span={2}>
                                        <Button className="ant-btn table-operation submit-button ant-btn-primary" onClick={() => { this.props.history.push("enquiry"); }}>
                                            Back
                                        </Button>
                                    </Col>
                                    <Col span={2}>
                                        <Button htmlType="submit" className="submit-button" type="primary">
                                            Submit
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Row>
                    </div>
                </div>
            </Content>
        )
    }
}
const AddEnquiry = Form.create()(MI);
export default AddEnquiry;